import type { ReactNode } from "react";
import { HelmetProvider } from "react-helmet-async";
import "../i18n";

export function AppProviders({ children }: { children: ReactNode }) {
  return <HelmetProvider>{children}</HelmetProvider>;
}
